module.exports = __webpack_public_path__ + "img/隨緣自強3.5 的副本.d1321c9a.jpg";